import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil, finalize } from 'rxjs/operators';
import { ForgotPasswordModel, ResetPasswordModel } from 'src/app/models/response/forgot-password';
import { ResultOfT } from 'src/app/models/response/result';
import { UserInfoResponseModel } from 'src/app/models/response/userInfo-response';
import { BaseComponent } from 'src/app/shared/base.component';
import { Constants } from 'src/app/shared/constants';
import { CustomValidator } from 'src/app/shared/custom-validator';
import { environment } from 'src/environments/environment';
import { MigrationClientService } from '../services/migration-client.service';
import { MigrationClientResponseModel } from '../models/response/migration-client-response';
import { WebStorageService } from '../services/web-storage.service';

@Component({
  selector: 'app-reset-migration-client-password',
  templateUrl: './reset-migration-client-password.component.html',
  styleUrls: ['./reset-migration-client-password.component.sass']
})
export class ResetMigrationClientPasswordComponent extends BaseComponent implements OnInit {

  private unsubscriber = new Subject<boolean>();
  private progress = new Subject<boolean>();

  title = 'DocuWare Migration Tool';
  h2title = 'Reset Password';
  queryString: string;

  displayMessage: boolean = false;
  message: string = '';
  messageClass: boolean;
  passwordresetSuccessful: any = 0;

  forgotPasswordRequestModel: ForgotPasswordModel;
  resetPasswordModel: ResetPasswordModel;
  displayForm: boolean;
  modifiedBy: number;

  constructor(private formBuilder: FormBuilder, private migrationService: MigrationClientService,
    private router: Router, private activatedRoute: ActivatedRoute, private webStorageService: WebStorageService) {
    super();
    let currentUser = this.webStorageService.getCurrentUserToken();
    if (currentUser) {
      this.modifiedBy = currentUser.userId;
    }
  }

  ngOnDestroy() {
    if (this.unsubscriber) {
      this.unsubscriber.next();
      this.unsubscriber.complete();
    }
    if (this.progress) {
      this.progress.complete();
    }
  }

  formFields =
    {
      newPassword: 'newPassword',
      confirmPassword: 'confirmPassword'
    };

  validationMessages = {
    password: {
      required: 'Password is required',
      minlength: 'Password should be at least 8 characters',
      invalid: 'Enter valid password'
    },
    confirmPassword: {
      required: 'Confirm password is required',
      invalid: 'Enter valid confirm password',
      minlength: 'Password should be at least 6 characters',
      validPasswordMatch: 'Password doesn\'t match'
    }
  };


  ngOnInit(): void {

    this.forgotPasswordRequestModel = new ForgotPasswordModel();
    this.resetPasswordModel = new ResetPasswordModel();

    this.activatedRoute.params
      .pipe(takeUntil(this.unsubscriber))
      .subscribe((params: Params) => {
        this.queryString = params['queryString'];
      });

    if (this.queryString) {
      this.forgotPasswordRequestModel.encryptedString = this.queryString + "=";
    }
    // this.buildForm();

    this.authenticatePaswordChangeRequest();
  }

  private authenticatePaswordChangeRequest() {

    this.migrationService.authenticateForgotPasswordRequest(this.forgotPasswordRequestModel)
      .pipe(takeUntil(this.unsubscriber), finalize(() => this.loading = false))
      .subscribe((result: ResultOfT<MigrationClientResponseModel>) => {
        this.processResult<any>(result, () => {
          if (result.IsSuccess) {
            if (result.ResponseModel) {
              this.resetPasswordModel.userId = result?.ResponseModel?.ClientId;
              this.resetPasswordModel.email = result?.ResponseModel?.Email;
              this.displayForm = true;

              this.buildForm();
            }

          }
          else {
            this.displayForm = false;
            this.loading = false;
            this.message = result.Message;
            // this.timeoutFunct(result.Message, false);
          }
        });
      }, (httpResponseError) => {
        this.loading = false;
        this.timeoutFunct(httpResponseError.message, false);
      });
  }

  onSubmit() {

    if (this.form.invalid) {
      this.markFormAsTouched();
      return;
    }

    this.resetPasswordModel.password = this.form.get(this.formFields.newPassword).value;
    this.resetPasswordModel.modifiedBy = this.modifiedBy
    this.migrationService.resetPassword(this.resetPasswordModel)
      .pipe(takeUntil(this.unsubscriber), finalize(() => this.loading = false))
      .subscribe((result: ResultOfT<any>) => {
        this.processResult<any>(result, () => {
          if (result.IsSuccess) {
            if (result.ResponseModel) {
              this.timeoutFunct("Password updated successfully", true);
              setTimeout(() => {
                //Need to add the correct redirection
                //this.router.navigate(['/login']);
              }, environment.messageLifeSpan);
              this.passwordresetSuccessful = 1;
              this.displayForm = false;
            }


          }
          else {
            this.loading = false;
            this.timeoutFunct(result.Message, false);
          }
        });
      }, (httpResponseError) => {
        this.loading = false;
        this.timeoutFunct(httpResponseError.message, false);
      });

  }

  timeoutFunct(msg, isSuccess: boolean) {
    this.displayMessage = true;
    this.messageClass = isSuccess;
    this.message = msg;
    setTimeout(() => {
      this.message = '';
      this.displayMessage = false;
    }, environment.messageLifeSpan);
  }

  closeMessagePopup() {
    this.displayMessage = false;
  }

  private buildForm() {
    const formGroup = this.formBuilder.group({});

    // tslint:disable-next-line: max-line-length
    formGroup.addControl(this.formFields.newPassword, this.formBuilder.control('', {
      validators: [Validators.required, Validators.minLength(8), CustomValidator.whitespace, CustomValidator.passwordPattern],
      updateOn: Constants.formControlUpdateStrategy.blur
    }));
    // tslint:disable-next-line: max-line-length
    formGroup.addControl(this.formFields.confirmPassword, this.formBuilder.control('', {
      validators: [Validators.required, CustomValidator.whitespace, CustomValidator.passwordPattern],
      updateOn: Constants.formControlUpdateStrategy.blur
    }));
    formGroup.setValidators(CustomValidator.passwordMatch('newPassword', 'confirmPassword'));
    this.form = formGroup;
  }


}
